import React from "react";
import SimpleCrudPage from "@/components/SimpleCrudPage";
import { apiListSupplier, apiCreateSupplier, apiUpdateSupplier } from "@/lib/api";

const FIELDS = [
  { key: "nama", label: "Nama", required: true },
  { key: "telepon", label: "Telepon" },
  { key: "alamat", label: "Alamat" },
  { key: "catatan", label: "Catatan" },
];
const API = { list: apiListSupplier, create: apiCreateSupplier, update: apiUpdateSupplier };

export default function SupplierManagement() {
  return <SimpleCrudPage testId="supplier" title="Master Supplier" subtitle="Pemasok bahan baku." fields={FIELDS} api={API} />;
}
